// extracted by mini-css-extract-plugin
export default {"main":"Page_main__UAmBN","inner":"Page_inner__NzybS","overflowHidden":"Page_overflowHidden__vbaA1"};